/* Copyright (c) 2015-present, salesforce.com, inc. All rights reserved */
/* Licensed under BSD 3-Clause - see LICENSE.txt or git.io/sfdc-license */

export SLDSSettings from './settings';
export Settings from './settings';

export SLDSIconSettings from './icon-settings';
export IconSettings from './icon-settings';

export SLDSAccordion from './accordion';
export Accordion from './accordion';

export SLDSAccordionPanel from './accordion/panel';
export AccordionPanel from './accordion/panel';

export SLDSAlert from './alert';
export Alert from './alert';

export SLDSAlertContainer from './alert/container';
export AlertContainer from './alert/container';

export SLDSAppLauncher from './app-launcher';
export AppLauncher from './app-launcher';

export SLDSAppLauncherTile from './app-launcher/tile';
export AppLauncherTile from './app-launcher/tile';

export SLDSAppLauncherSection from './app-launcher/section';
export AppLauncherSection from './app-launcher/section';

export SLDSAvatar from './avatar';
export Avatar from './avatar';

export SLDSBrandBand from './brand-band';
export BrandBand from './brand-band';

export SLDSButton from './button';
export Button from './button';

export SLDSButtonGroup from './button-group';
export ButtonGroup from './button-group';

export SLDSButtonStateful from './button-stateful';
export ButtonStateful from './button-stateful';

/* Remove at next breaking change */
export SLDSBreadCrumb from './breadcrumb';
export BreadCrumb from './breadcrumb';

export SLDSBreadcrumb from './breadcrumb';
export Breadcrumb from './breadcrumb';

export SLDSCard from './card';
export Card from './card';

export SLDSCardEmpty from './card/empty';
export CardEmpty from './card/empty';

export SLDSCardFilter from './card/filter';
export CardFilter from './card/filter';

export SLDSCheckbox from './forms/checkbox';
export Checkbox from './forms/checkbox';

export SLDSColorPicker from './color-picker';
export ColorPicker from './color-picker';

export SLDSCombobox from './combobox';
export Combobox from './combobox';

export SLDSComboboxFilterAndLimit from './combobox/filter';
export comboboxFilterAndLimit from './combobox/filter';
export comboboxAddSubheadings from './combobox/add-subheadings';

export SLDSGlobalHeader from './global-header';
export GlobalHeader from './global-header';

export SLDSGlobalHeaderButton from './global-header/button';
export GlobalHeaderButton from './global-header/button';

export SLDSGlobalHeaderDropdown from './global-header/dropdown';
export GlobalHeaderDropdown from './global-header/dropdown';

export SLDSGlobalHeaderProfile from './global-header/profile';
export GlobalHeaderProfile from './global-header/profile';

export SLDSGlobalHeaderSearch from './global-header/search';
export GlobalHeaderSearch from './global-header/search';

export SLDSGlobalNavigationBar from './global-navigation-bar';
export GlobalNavigationBar from './global-navigation-bar';

export SLDSGlobalNavigationBarRegion from './global-navigation-bar/region';
export GlobalNavigationBarRegion from './global-navigation-bar/region';

export SLDSGlobalNavigationBarLink from './global-navigation-bar/link';
export GlobalNavigationBarLink from './global-navigation-bar/link';

export SLDSGlobalNavigationBarDropdown from './global-navigation-bar/dropdown';
export GlobalNavigationBarDropdown from './global-navigation-bar/dropdown';

export SLDSDataTable from './data-table';
export DataTable from './data-table';

export SLDSDataTableCell from './data-table/cell';
export DataTableCell from './data-table/cell';

export SLDSDataTableHighlightCell from './data-table/highlight-cell';
export DataTableHighlightCell from './data-table/highlight-cell';

export SLDSDataTableColumn from './data-table/column';
export DataTableColumn from './data-table/column';

export SLDSDataTableRowActions from './data-table/row-actions';
export DataTableRowActions from './data-table/row-actions';

export SLDSDatepicker from './date-picker';
export Datepicker from './date-picker';

export SLDSIcon from './icon';
export Icon from './icon';

export SLDSIllustration from './illustration';
export Illustration from './illustration';

// TODO: Should probably be removed from export and only used internally. This component does not implement Button Icons per SLDS, but only the icons in buttons
export SLDSButtonIcon from './icon/button-icon';
export ButtonIcon from './icon/button-icon';

export SLDSFilter from './filter';
export Filter from './filter';

export SLDSInlineEdit from './forms/input/inline';
export InlineEdit from './forms/input/inline';

export SLDSInput from './input';
export Input from './input';

export SLDSSearch from './input/search';
export Search from './input/search';

export SLDSInputIcon from './icon/input-icon';
export InputIcon from './icon/input-icon';

export SLDSLookup from './lookup';
export Lookup from './lookup';
export SLDSLookupDefaultFooter from './lookup/menu/default-footer';
export LookupDefaultFooter from './lookup/menu/default-footer';
export SLDSLookupDefaultHeader from './lookup/menu/default-header';
export LookupDefaultHeader from './lookup/menu/default-header';
export SLDSLookupDefaultSectionDivider from './lookup/menu/default-section-divider';
export LookupDefaultSectionDivider from './lookup/menu/default-section-divider';

export SLDSMediaObject from './media-object';
export MediaObject from './media-object';

export SLDSMenuDropdown from './menu-dropdown';
export Dropdown from './menu-dropdown';
export SLDSDropdownTrigger from './menu-dropdown/button-trigger';
export DropdownTrigger from './menu-dropdown/button-trigger';

export SLDSMenuPicklist from './menu-picklist';
export Picklist from './menu-picklist';

export SLDSModal from './modal';
export Modal from './modal';

export SLDSModalTrigger from './modal/trigger';
export ModalTrigger from './modal/trigger';

export SLDSNavigation from './vertical-navigation';
export Navigation from './vertical-navigation';

export SLDSNotification from './notification';
export Notification from './notification';

export SLDSPanel from './panel';
export Panel from './panel';
export SLDSPanelFilterGroup from './panel/filtering/group';
export PanelFilterGroup from './panel/filtering/group';
export SLDSPanelFilterList from './panel/filtering/list';
export PanelFilterList from './panel/filtering/list';
export SLDSPanelFilterListHeading from './panel/filtering/list-heading';
export PanelFilterListHeading from './panel/filtering/list-heading';

export SLDSPageHeader from './page-header';
export PageHeader from './page-header';

export SLDSPill from './pill';
export Pill from './pill';

export SLDSPillContainer from './pill-container';
export PillContainer from './pill-container';

export SLDSPopover from './popover';
export Popover from './popover';

export SLDSPopoverTooltip from './tooltip';
export PopoverTooltip from './tooltip';
export SLDSTooltip from './tooltip';
export Tooltip from './tooltip';

export SLDSProgressIndicator from './progress-indicator';
export ProgressIndicator from './progress-indicator';

export SLDSProgressRing from './progress-ring';
export ProgressRing from './progress-ring';

export SLDSRadio from './radio';
export Radio from './radio';

export SLDSRadioButtonGroup from './radio-button-group';
export RadioButtonGroup from './radio-button-group';

export SLDSRadioGroup from './radio-group';
export RadioGroup from './radio-group';

export SLDSSlider from './slider';
export Slider from './slider';

export SLDSSpinner from './spinner';
export Spinner from './spinner';

// Remove at next breaking change
export SLDSSplitview from './split-view';
export Splitview from './split-view';

export SLDSSplitView from './split-view';
export SplitView from './split-view';

export SLDSSplitViewHeader from './split-view/header';
export SplitViewHeader from './split-view/header';

export SLDSSplitViewListbox from './split-view/listbox';
export SplitViewListbox from './split-view/listbox';

export SLDSTextarea from './textarea';
export Textarea from './textarea';

export SLDSTimepicker from './time-picker';
export Timepicker from './time-picker';

export SLDSTabs from './tabs';
export Tabs from './tabs';
export SLDSTabsPanel from './tabs/panel';
export TabsPanel from './tabs/panel';

export SLDSToast from './toast';
export Toast from './toast';
export SLDSToastContainer from './toast/container';
export ToastContainer from './toast/container';

export SLDSUtilityIcon from './utilities/utility-icon';
export UtilityIcon from './utilities/utility-icon';

export SLDSTree from './tree';
export Tree from './tree';

export SLDSVerticalNavigation from './vertical-navigation';
export VerticalNavigation from './vertical-navigation';

// Library utilities
export log from '../utilities/log';
